import { render, staticRenderFns } from "./MenuFavorites.vue?vue&type=template&id=5aca1bfb&scoped=true&"
import script from "./MenuFavorites.vue?vue&type=script&lang=js&"
export * from "./MenuFavorites.vue?vue&type=script&lang=js&"
import style0 from "./MenuFavorites.vue?vue&type=style&index=0&id=5aca1bfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca1bfb",
  null
  
)

export default component.exports